export default __webpack_public_path__ + "static/profile_pic-043175340efeae886afb47b7f6b8ddb0.jpg";